import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { posthog } from "@/lib/posthog";
import * as Sentry from "@sentry/react";

export const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    // Start Sentry span for page view performance tracking
    const span = Sentry.startInactiveSpan({
      name: `pageview: ${location.pathname}`,
      op: 'navigation',
    });
    
    // Push page view to GTM dataLayer
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: "page_view",
        page_url: window.location.href,
        page_title: document.title,
        page_path: location.pathname,
      });
    }

    // Push page view to PostHog
    if (posthog.__loaded) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        path: location.pathname,
      });
    }

    if (import.meta.env.DEV) {
      console.log("📄 Page view tracked:", location.pathname);
    }
    
    // Finish span after initial render
    if (span) {
      const finishSpan = setTimeout(() => {
        span.end();
      }, 100);
      
      return () => {
        clearTimeout(finishSpan);
        span.end();
      };
    }
  }, [location]);
};
